// REST client for the account-settings passkey management endpoints
// (/api/webauthn_credentials): list saved passkeys, start registration,
// create/rename/delete one. This is for managing already-signed-in users'
// passkeys; sign-in-time authentication calls live in utils/loginApi.js.
import apiFetch from "../apiFetch";

const parseErrorMessage = async (response, fallback) => {
  const body = await response.json().catch(() => null);
  return body?.message || fallback;
};

export const listPasskeys = async () => {
  const response = await apiFetch("/api/webauthn_credentials");
  if (!response.ok) throw new Error("Failed to load passkeys.");
  return response.json();
};

export const getPasskeyRegistrationOptions = async () => {
  const response = await apiFetch(
    "/api/webauthn_credentials/registration_options",
    {
      method: "POST",
    }
  );
  if (!response.ok) throw new Error("Failed to start passkey registration.");
  return response.json();
};

export const createPasskey = async (credential, nickname) => {
  const response = await apiFetch("/api/webauthn_credentials", {
    method: "POST",
    body: JSON.stringify({ credential, nickname }),
  });
  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(response, "Failed to save passkey.")
    );
  }
  return response.json();
};

export const renamePasskey = async (id, nickname) => {
  const response = await apiFetch(`/api/webauthn_credentials/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ nickname }),
  });
  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(response, "Failed to rename passkey.")
    );
  }
  return response.json();
};

export const deletePasskey = async (id) => {
  const response = await apiFetch(`/api/webauthn_credentials/${id}`, {
    method: "DELETE",
  });
  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(response, "Failed to remove passkey.")
    );
  }
};
